import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Navbar from './Navbar';
import Footer from './Footer';
import ToastViewport from '@/components/ui/Toast';
import ScrollProgressBar from '@/components/ui/ScrollProgressBar';

export default function PublicLayout() {
  const location = useLocation();

  return (
    <>
      <ScrollProgressBar />
      <Navbar />
      <AnimatePresence mode="wait" initial={false}>
        <motion.main
          key={location.pathname}
          id="main-content"
          className="pt-16 md:pt-20 min-h-[60vh]"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
        >
          <Outlet />
        </motion.main>
      </AnimatePresence>
      <Footer />
      <ToastViewport />
    </>
  );
}
